// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserLastLoginCell} from './UserLastLoginCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserCustomHeader} from './UserCustomHeader'
import {User} from '../../core/_models'
import moment from 'moment'
import {Badge} from 'react-bootstrap'
import {numberFormat} from '../../../../../../utils/Functions'
import StateLabel from '../../../../../../components/grid/StateLabel'
import StateActionGroup from '../../../StateActionGroup'
import {Link} from 'react-router-dom'
import {useBatchApproval} from '../../../../../../context/BatchApprovalContext'

const usersColumns: any = (onUpdate) => ([
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='' />
    ),
    id: 'selection',
    Cell: ({row}: any) => {
      const {selectedDocs, toggleDoc} = useBatchApproval()
      const doc = row.original
      return (
        <input
          type='checkbox'
          className='form-check-input'
          style={{border: '1px solid #C3C3C3'}}
          checked={selectedDocs.has(doc.id)}
          onChange={() => toggleDoc(doc)}
        />
      )
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='เลขที่เอกสาร' className='min-w-125px' />,
    id: 'id',
    accessor: 'code',
    Cell: (r) => {
      const origin = r.row.original
      return <Link to={`/expense-purchase-order/${origin.id}/detail`}>{r.value || '-'}</Link>
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='ชื่อผู้ขาย' className='min-w-150px' />,
    id: 'fullName',
    accessor: 'labCompany',
    Cell: (r) => <span>{r.value?.name || '-'}</span>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='วันที่ออก' className='min-w-125px' />,
    id: 'date',
    accessor: 'date',
    Cell: (r) => <span>{moment(r.value).format('DD/MM/YYYY')}</span>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='มูลค่าสุทธิ' className='min-w-125px' />,
    id: 'totalAmount',
    accessor: 'totalAmount',
    Cell: (r) => <span>{numberFormat(r.value || 0)}</span>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='คำสั่ง' className='min-w-125px' />,
    id: 'state',
    accessor: 'state',
    Cell: (r) => (
      <div className={'l-grid-action-wrapper'}>
        <StateActionGroup data={r.row.original} />
      </div>
    ),
  },
])

export {usersColumns}
